// import { useTranslation } from "react-i18next";
// import Header from "../shared/Header";
// import AgreeButton from "./AgreeButton";
// import CompanyIdInput from "./CompanyIdInput";
// import ConsentCheckbox from "./ConsentCheckbox";
// import { TermsAndConditions } from "./TermsAndConditions";
// import { useEffect, useState } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";

// const baseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

// const B2BTmc = () => {
//   const navigate = useNavigate();
//   const { t, i18n } = useTranslation();
//   const [searchParams] = useSearchParams();
//   const token = searchParams.get("token");
//   const [isChecked, setIsChecked] = useState<boolean>(false);
//   const [companyId, setCompanyId] = useState<string>("");
//   const [tokenValid, setTokenValid] = useState<boolean | null>(null);
//   const [isSuccess, setIsSuccess] = useState<boolean>(false);

//   useEffect(() => {
//     async function checkToken() {
//       try {
//         const response = await fetch(
//           `${baseUrl}/api/tmc/check-token?token=${token}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "text/plain",
//               langcode: i18n.language ?? "ka",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ token }),
//           }
//         );

//         if (!response.ok) throw new Error("Invalid token");
//         setTokenValid(true);
//       } catch {
//         navigate(`/${i18n.language}/error`, {
//           state: {
//             title: t("tmc.tokenErrorTitle"),
//             description: t("tmc.tokenErrorDescription"),
//             errorBtn: "hide",
//           },
//         });
//         setTokenValid(false);
//       }
//     }
//     if (token) {
//       checkToken();
//     } else {
//       setTokenValid(false);
//     }
//   }, [token, i18n.language]);

//   if (tokenValid === false) {
//     // return <ErrorPage />;
//   }

//   if (tokenValid === null) {
//     return (
//       <div className="flex items-center justify-center h-screen bg-gray-100">
//         <div className="text-lg">{t("checkingLink")}</div>
//       </div>
//     );
//   }

//   if (isSuccess) {
//     // return <SuccessPage />;
//   }

//   const handleCheckboxChange = (checked: boolean) => {
//     setIsChecked(checked);
//   };

//   const handleCompanyIdChange = (id: string) => {
//     setCompanyId(id);
//   };
//   return (
//     <div className="bg-gray-100 h-full min-h-screen">
//       <Header />
//       <div className="pb-15">
//         <div className="flex flex-col bg-white px-8 mt-10 mx-auto max-w-[1000px] rounded-lg">
//           <TermsAndConditions />
//           <div className="flex flex-col items-center gap-8 p-4 w-full  rounded-md my-6">
//             <CompanyIdInput
//               value={companyId}
//               onCompanyIdChange={handleCompanyIdChange}
//             />

//             <ConsentCheckbox
//               checked={isChecked}
//               onChange={handleCheckboxChange}
//               label={t("tmc.terms")}
//             />

//             <AgreeButton
//               disabled={!isChecked || !companyId}
//               setIsSuccess={setIsSuccess}
//               companyId={companyId}
//               isChecked={isChecked}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default B2BTmc;

import { useTranslation } from "react-i18next";
import Header from "../shared/Header";
import AgreeButton from "./AgreeButton";
import CompanyIdInput from "./CompanyIdInput";
import ConsentCheckbox from "./ConsentCheckbox";
import { TermsAndConditions } from "./TermsAndConditions";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Container from "../shared/Container";
import arrowDown from "@src/assets/icons/arrowDown.svg";

const baseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

const B2BTmc = () => {
  const formRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [companyId, setCompanyId] = useState<string>("");
  const [tokenValid, setTokenValid] = useState<boolean | null>(null);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  useEffect(() => {
    async function checkToken() {
      try {
        const response = await fetch(
          `${baseUrl}/api/tmc/check-token?token=${token}`,
          {
            method: "POST",
            headers: {
              accept: "text/plain",
              langcode: i18n.language ?? "ka",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
          }
        );

        if (!response.ok) throw new Error("Invalid token");
        setTokenValid(true);
      } catch {
        navigate(`/${i18n.language}/error`, {
          state: {
            title: t("tmc.tokenErrorTitle"),
            description: t("tmc.tokenErrorDescription"),
            errorBtn: "hide",
          },
        });
        setTokenValid(false);
      }
    }
    if (token) {
      checkToken();
    } else {
      setTokenValid(false);
    }
  }, [token, i18n.language]);

  if (tokenValid === false) {
    // return <ErrorPage />;
  }

  if (tokenValid === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="text-lg">{t("checkingLink")}</div>
      </div>
    );
  }

  if (isSuccess) {
    // return <SuccessPage />;
  }
  const handleScrollDown = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCheckboxChange = (checked: boolean) => {
    setIsChecked(checked);
  };

  const handleCompanyIdChange = (id: string) => {
    setCompanyId(id);
  };
  return (
    <Container
      className="max-md:min-h-[100vh] max-md:bg-white relative"
      containerWith="1000px"
    >
      {/* Overlay Scroll Down Button */}
      <button
        type="button"
        onClick={handleScrollDown}
        className="fixed bottom-6 right-6 z-50 bg-amber-600 hover:bg-amber-700 transition p-2 rounded-full shadow-lg"
        style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}
        aria-label="Scroll Down"
      >
        <img src={arrowDown} alt="Scroll Down" className="w-6 h-6" />
      </button>

      <div className="pb-15">
        <div className="flex flex-col bg-white mt-10 mx-auto max-w-[1000px] rounded-lg">
          <TermsAndConditions />
          <div
            ref={formRef}
            className="flex flex-col items-center gap-8 p-4 w-full rounded-md my-6"
          >
            <CompanyIdInput
              value={companyId}
              onCompanyIdChange={handleCompanyIdChange}
            />
            <ConsentCheckbox
              checked={isChecked}
              onChange={handleCheckboxChange}
              label={t("tmc.terms")}
            />
            <AgreeButton
              disabled={!isChecked || !companyId}
              setIsSuccess={setIsSuccess}
              companyId={companyId}
              isChecked={isChecked}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};

export default B2BTmc;
